.portal-root {
  z-index: 1000;
  position: absolute;
  .ui__select-menu:after,
  .ui__select-menu:before {
    bottom: calc(100% - 13px) !important;
  }
}

.portal-align-left {
  .ui__select-menu:after,
  .ui__select-menu:before {
    left: 10px !important;
  }
}
.portal-align-right {
  .ui__select-menu:after,
  .ui__select-menu:before {
    right: 10px;
  }
}
